 import { useContext, useEffect, useRef, useState, useMemo, forwardRef, useImperativeHandle, useCallback } from "react";
import { Typography, List, ListItem, ListItemText, ListItemIcon, IconButton, Button, Stack, Zoom, Grid, Popover, ListItemButton, Tabs, Tab, Chip, Autocomplete } from "@mui/material";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import { Accordion, AccordionSummary, AccordionDetails, CustomAutocompleteBill } from "../../styles/style";
import { MyDialog } from "../../component/index";
import { title_transition } from "../../mock-data/data";
import { GradienCheckCircleIcon, GradienCancelIcon, GradienFirstMonthIcon } from "../../component/icons/icon-gradient";
import Tooltip from "@mui/material/Tooltip";
import DataSourceContext from "../../context/DataSourceMngContext";
import InfoIcon from "@mui/icons-material/Info";
import ImagePreviewWithOverview from "../data-source/images/image-preview";
import { formatInput, insertCommas } from "../../utils/formatInput";
import { DialogImageAnnotate } from "./dialog-image-annotate";
import DialogCreateAsset from "./dialog-create-asset";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm, Controller } from "react-hook-form";
import { numberDecimalFormat, formatNumber } from "src/utils/number-format";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { BillFormContent } from "../../component/billFormContent";
import { WaterMeterFormContent } from "../../component/waterMeterFormContent";
import { HuaweiContent } from "../../component/huaweiContent";

dayjs.extend(buddhistEra);
dayjs.locale("th");

function ContentsErr({ onClick }) {
  const { bill } = useContext(DataSourceContext);

  return (
    <Stack spacing={2}>
      <Typography
        sx={{
          fontSize: "20px",
          color: "red",
          fontWeight: 600, // น้ำหนักตัวอักษร
          textShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)", // เพิ่มเงาตัวอักษร
        }}
      >
        {bill?.message}
      </Typography>
      <Zoom in={true}>
        <img
          src={bill?.url}
          alt=""
          style={{ height: "500px", width: "auto", borderRadius: "12px" }}
        />
      </Zoom>
      <Button
        variant="outlined"
        sx={{ width: "fit-content" }}
        onClick={() => onClick(false)}
      >
        Back
      </Button>
    </Stack>
  );
}

const  OCRSContents = forwardRef(({ onClose, selectTransaction, handleSelectTransaction }, ref) => {
  const {
    history,
    historyDetail,
    updateHistoryDetail,
    updateTransactionDetails,
    fetchHistoryDetail,
    fetchAsset,
    historyDetailImage,
    fetchEmissions,
    self_upload_type,
    setDataState,
    mode,selectServer,
    updateDetailsWasteTravelling,
    fetchAliasTransaction,
    tansactionById
  } = useContext(DataSourceContext);


  const { register, handleSubmit, formState: { errors }, setValue, reset, watch, control } = useForm();
  const [indexTransaction, setIndexTransaction] = useState(-1);
  const [openAnnotate, setOpenAnnotate] = useState(false);
  const [showDeleteIdx, setShowDeleteIdx] = useState(null);
  const formRef = useRef(null);
  const [formData, setFormData] = useState({});
  const [transactions, setTransactions] = useState({});
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectId, setSelectId] = useState("");
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const billItemRefs = useRef({});

  const [assets, setAssets] = useState([{ title: "Create new asset" }]);
  const [isLoadingAssets, setIsLoadingAssets] = useState(false);
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [emissions, setEmissions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null);
  const [aliasOptions, setAliasOptions] = useState([]); 
  const [serialNumberList, setSerialNumberList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'popover' : undefined;

  const getAssets = async (forceRefresh = false) => {
    // Skip if already loaded and not forcing refresh
    if (assetsLoaded && !forceRefresh) return;
    
    setIsLoadingAssets(true);
    try {
      const dataSourceId = historyDetail?.data_source_transaction_detail;
      const fetchedAssets = await fetchAsset(dataSourceId);

      setAssets([
        { title: "Create new asset" },
        {
          title: "No asset",
          nameEnglish: "",
          nameThai: "",
          licensePlate: "",
          plant_id: null,
        },
        ...fetchedAssets,
      ]);
      setAssetsLoaded(true);
    } catch (error) {
      console.error("Error fetching assets:", error);
    } finally {
      setIsLoadingAssets(false);
    }
  };

  // Handler for Autocomplete onOpen - fetch assets on demand
  // const handleAssetsDropdownOpen = () => {
  //   console.log(historyDetail)
  //   if (!assetsLoaded && !isLoadingAssets) {
  //     getAssetsById(historyDetail?.data_source_transaction_detail, true);
  //   }
  // };

  const getEmissions = async () => {
    const emissions = await fetchEmissions();
    setEmissions(emissions);
  };

  useImperativeHandle(ref, () => ({
    handleSaveChanges: () => {
      formRef.current?.requestSubmit();
    },
  }));

  const getAliasTransaction = async () => {
    const aliasTransaction = await fetchAliasTransaction();
    setAliasOptions(aliasTransaction);
  };

  useEffect(() => {
    getAliasTransaction();
  }, []);

  const getAssetsById = useCallback(async (id, forceRefresh = false) => {
    if (assetsLoaded && !forceRefresh) return;
    
    setIsLoadingAssets(true);
    try {
      const assets = await fetchAsset(id);
      setAssets([
        { title: "Create new asset" },
        ...assets,
      ]);
      setAssetsLoaded(true);
    }catch (error) {
      setAssets([
        { title: "Create new asset" },
        {
          title: "No asset",
          nameEnglish: "",
          nameThai: "",
          licensePlate: "",
          plant_id: null,
        },
      ]);
    }finally {
      setIsLoadingAssets(false);
    }
  }, [fetchAsset]);

  useEffect(() => {

    if (historyDetail) {
      const { data_source_transaction_detail, details, ...rest } =
        historyDetail;

      // Reset assets loaded flag when historyDetail changes (will fetch on dropdown open)
      setAssetsLoaded(false);
      setAssets([{ title: "Create new asset" }]);
      
      getEmissions();

      // Clear transactions state before adding new data
      setTransactions({});

      if(details){
        details?.forEach((trans) => {
          setTransactions((prev) => ({
            ...prev,
            [trans?.id]: {
              ...trans,
              unit: insertCommas(trans?.unit),
            },
            }));
        });
      }else{
        setTransactions(historyDetail);
      }

      // Initialize form with bills array for bill type (including nested transactions)
      const billsInitialData = details?.map((bill) => ({
        id: bill?.id,
        activity_date: bill?.activity_date?.split("T")[0] || "",
        date: bill?.date?.split("T")[0] || "",
        bill_type: bill?.bill_type || "",
        asset_type_name: bill?.asset_type_name || "",
        invoice_id: bill?.invoice_id || "",
        tax_id: bill?.tax_id || "",
        address: bill?.address || "",
        supplier_name: bill?.supplier_name || "",
        supplier_tax_id: bill?.supplier_tax_id || "",
        supplier_address: bill?.supplier_address || "",
        // Include nested transactions data
        transactions: bill?.details?.map((trans) => ({
          id: trans?.id,
          transaction_dap_id: trans?.transaction_dap_id,
          confidence: trans?.confidence,
          unit: trans?.unit,
          plant_id: trans?.plant_id,
          asset_title: trans?.title,
          asset_en: trans?.asset_en,
          asset_th: trans?.asset_th,
          license_plate: trans?.license_plate,
          emission_list: trans?.emission_list,
          convert_unit: trans?.convert_unit,
        })) || [],
      })) || [];

      reset({
        ...rest,
        id: data_source_transaction_detail,
        activity_date: rest?.activity_date ? rest.activity_date.split("T")[0] : "",
        date: rest?.date ? rest.date.split("T")[0] : "",
        serial_number: rest?.serial_number || "",
        station_name: rest?.station_name || "",
        alias_name: rest?.alias_name || "",
        bills: billsInitialData,
        company_name: rest?.company_partner?.name || "",
        company_tax_id: rest?.company_partner?.tax_id || "",
        company_address: rest?.company_partner?.address || "",
        branch_name: rest?.plant_partner?.name || "",
        branch_address: rest?.plant_partner?.address || "",
        branch_tax_id: rest?.plant_partner?.tax_id || "",
      });
    }
  }, [historyDetail, reset, selectServer?.code]);

  // Set selectedItem when historyDetail changes
  useEffect(() => {
    if (historyDetail?.id && history) {
      // Find the matching item in history array
      for (const h of history) {
        if (h?.items) {
          const matchingItem = h.items.find(item => item?.id === historyDetail?.id);
          if (matchingItem) {
            setSelectedItem(matchingItem);
            return;
          }
        }
      }
    }
  }, [historyDetail, history]);

  const _assets = useMemo(() => {
    return [...assets];
  }, [assets]);

  const _emissions = useMemo(() => {
    return emissions?.map((item) => ({
      id: item?.id,
      emission_list: item?.name,
    }));
  }, [emissions]);

  const _stations = useMemo(() => {
    if (self_upload_type === 'water_meter') {
      return history?.flatMap((historyItem) => 
        historyItem?.items?.map((item) => ({
          id: item?.id,
          station_name: item?.serial_number,
          station_code: item?.serial_number,
        })) || []
      ) || [];
    } else {
      return history?.map((item) => ({
        id: item?.id,
        station_name: item?.station_name,
        station_code: item?.station_code,
        status: item?.status,
      }));
    }
  }, [history]);

  // Set the first station as default when stations are loaded
  useEffect(() => {
    if (_stations && _stations.length > 0 && !selectedStation) {
      setSelectedStation(_stations[0]);
      fetchHistoryDetail(_stations[0]?.id);
      handleSelectDetail(_stations[0]);
      
      // For water meter, also select the first transaction
      if (self_upload_type === 'water_meter' && _stations[0]) {
        handleSelectDetail(_stations[0]);
        setSerialNumberList(history?.map(h => h?.serial_number));
      }
    }
  }, [_stations, selectedStation]);

  // Set "ทั้งหมด" as default when modal opens and history is loaded
  useEffect(() => {
    if (history && history.length > 0) {
      setIndexTransaction(-1); // -1 = ทั้งหมด
    }
  }, [history]);

  const handleInputNumberChange = (value, key) => {
    setValue(key, formatInput(value));
  };

  const handleUnitChange = (transId, detailIndex, value) => {
    const _value = value
      .replace(/[^0-9.-]/g, "")
      .replace(/-/g, (match, offset) => (offset === 0 ? match : ""));
    const [integerPart, decimalPart] = _value.split(".");
    let result = insertCommas(integerPart);

    if (!!decimalPart) {
      result += `.${decimalPart}`;
    } else if (_value.includes(".")) {
      result += ".";
    }

    setTransactions((prev) => {
      const updatedDetails = [...(prev[transId]?.details || [])];
      const numericValue = result ? parseFloat(result.replace(/,/g, "")) : "";
      
      if (updatedDetails[detailIndex]) {
        updatedDetails[detailIndex] = {
          ...updatedDetails[detailIndex],
          unit: numericValue,  // เก็บเป็น number หรือ "" ถ้าว่าง
        };
      }
      return {
        ...prev,
        [transId]: {
          ...prev[transId],
          details: updatedDetails,
        },
      };
    });
  };

  const handleConfidenceChange = (transId, value) => {
    setTransactions((prev) => ({
      ...prev,
      [transId]: {
        ...prev[transId],
        confidence: value,
      },
    }));
  };

  const handleAssetChange = (transId, value) => {
    if (value?.title === "Create new asset") {
      setIsOpenDialog(true);
    }

    setTransactions((prev) => ({
      ...prev,
      [transId]: {
        ...prev[transId],
        plant_id: value?.plant_id ?? null,
        asset_en: value?.nameEnglish ?? "",
        asset_th: value?.nameThai ?? "",
        license_plate: value?.licensePlate ?? "",
        title: value?.title ?? "",
      },
    }));
  };

  const handleEmissionChange = (transId, value) => {
    setTransactions((prev) => ({
      ...prev,
      [transId]: {
        ...prev[transId],
        emission_list: value?.emission_list,
      },
    }));
  };

  const onSave = (data) => {
    try {
      const formatDate = (value) => value ? value.split?.("T")?.[0] || "" : "";
      const parseNumber = (value) => parseFloat(String(value ?? 0).replace(/,/g, "")) || 0;

      if(self_upload_type === 'water_meter'){
        const waterMeterPayload = {
          ...data,
          plant_master_data_id: data?.plant_master_data_id || historyDetail?.plant_partner?.id || null,
          details: Object.values(transactions).filter((item) => item !== null).map((item) => {
            const { title, unit, confidence, ...rest } = item;
            return {
              ...rest,
              unit: parseFloat(unit?.replace(/,/g, "") ?? 0),
              confidence: parseFloat(confidence ?? 0),
            };
          }),
        };
        updateTransactionDetails(waterMeterPayload);
      }else if (self_upload_type === 'xlsx_csv_waste' || self_upload_type === 'xlsx_csv_travelling'){
        const editedItemId = data?.itemId; // ID of the specific item that was edited
        const transactionId = selectTransaction?.id; // Main transaction ID (must be sent for all items)
        
        // Get all items from transactions or historyDetail.details
        const allItems = Object.keys(transactions)?.length > 0 
          ? Object.values(transactions) 
          : (historyDetail?.details || []);
        
        // Map all items and use formData if available, otherwise use original item data
        const payload = allItems.map((item, idx) => {
          const itemKey = item?.id !== undefined && item?.id !== null ? item?.id : idx;
          const editedData = formData[itemKey]; // Get edited data from formData if exists
          const addedId = selectTransaction?.status !== 'success';
          
          if (editedData) {
            // Use formData if this item was edited
            const payloadItem = {
              activity_date: editedData.activity_date !== undefined ? editedData.activity_date : (item?.activity_date?.split("T")[0] || item?.activity_date || ""),
              upload_date: editedData.upload_date !== undefined ? editedData.upload_date : (item?.upload_date?.split("T")[0] || item?.upload_date || ""),
              bill_type: editedData.bill_type !== undefined ? editedData.bill_type : (item?.bill_type || ""),
              type: editedData.type !== undefined ? editedData.type : (item?.type || ""),
              unit: editedData.unit !== undefined 
                ? Number(editedData.unit.toString().replace(/,/g, "") || 0) 
                : (typeof item?.unit === 'string' ? Number(item?.unit.replace(/,/g, "") || 0) : (item?.unit || 0)),
            };
            
            if (addedId) {
              payloadItem.id = transactionId;
            }else{
              delete payloadItem.id;
            }

            return payloadItem;
          } else {
            const payloadItem = { ...item };
            
            if (addedId) {
              payloadItem.id = transactionId;
            } else {
              // Remove id if status is not success
              delete payloadItem.id;
            }
            
            return payloadItem;
          }
        });
        updateDetailsWasteTravelling(payload, transactionId);
      }else{      
        // For bill type: use form data (data.bills) which includes nested transactions
        const billsData = data?.bills || [];
        
        const payload = billsData.map((formBillData, idx) => {
          const originalBill = historyDetail?.details?.[idx] || {};
          
          // Build bill payload with form data
          const billPayload = {
            id: formBillData.id || originalBill?.id,
            activity_date: formBillData.activity_date || formatDate(originalBill?.activity_date),
            date: formBillData.date || formatDate(originalBill?.date),
            bill_type: formBillData.bill_type || originalBill?.bill_type || "",
            asset_type_name: formBillData.asset_type_name || originalBill?.asset_type_name || "",
            invoice_id: formBillData.invoice_id || originalBill?.invoice_id || "",
            tax_id: formBillData.tax_id || originalBill?.tax_id || "",
            address: formBillData.address || originalBill?.address || "",
            supplier_name: formBillData.supplier_name || originalBill?.supplier_name || "",
            supplier_tax_id: formBillData.supplier_tax_id || originalBill?.supplier_tax_id || "",
            supplier_address: formBillData.supplier_address || originalBill?.supplier_address || "",
            // Include nested transactions from form data
            details: (formBillData.transactions || []).map((trans, transIdx) => {
              const originalTrans = originalBill?.details?.[transIdx] || {};
              return {
                id: trans.id || originalTrans?.id,
                transaction_dap_id: trans.transaction_dap_id || originalTrans?.transaction_dap_id,
                confidence: parseNumber(trans.confidence ?? originalTrans?.confidence),
                unit: parseNumber(trans.unit ?? originalTrans.unit),
                plant_id: trans.plant_id ?? originalTrans?.plant_id ?? null,
                title: trans.asset_title || originalTrans?.title || "",
                asset_en: trans.asset_en || originalTrans?.asset_en || "",
                asset_th: trans.asset_th || originalTrans?.asset_th || "",
                license_plate: trans.license_plate || originalTrans?.license_plate || "",
                emission_list: trans.emission_list || originalTrans?.emission_list || "",
                convert_unit: trans.convert_unit || originalTrans?.convert_unit || "",
              };
            }),
          };
          
          return billPayload;
        });

        const payloadWithId = {
          id: selectTransaction?.id,
          data: payload
        };
        updateHistoryDetail(payloadWithId);
      }

    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDialogCreateAsset = () => {
    setIsOpenDialog(false);
    // Force refresh assets after creating new asset
    getAssets(true);
  };

  const handleNewTransaction = () => {
    // If currently on "show all" (-1), go to first item (0)
    if (indexTransaction === -1 && history?.length > 0) {
      setIndexTransaction(0);
      const selectedTransaction = history?.[0];
      handleSelectDetail(selectedTransaction);
    } else if(indexTransaction < history?.length - 1){
      setIndexTransaction(indexTransaction + 1);
      const selectedTransaction = history?.[indexTransaction + 1];
      handleSelectDetail(selectedTransaction);
    }
  };

  const handleBackTransaction = () => {
    // If at first item (0), go back to "show all" (-1)
    if (indexTransaction === 0) {
      setIndexTransaction(-1);
    } else if(indexTransaction > 0){
      setIndexTransaction(indexTransaction - 1);
      const selectedTransaction = history?.[indexTransaction - 1];
      handleSelectDetail(selectedTransaction);
    }
  };

  const handleSelectDetail = (data) => {
    setShowDeleteIdx(null);
    setDataState((prev) => ({
      ...prev,
      // transection_details_id: data?.id,
      transection_details_id: self_upload_type === 'water_meter' 
      ? (data?.items?.[0]?.id || data?.id)  // ← fallback to data?.id
      : data?.id,
    }));

    handleSelectTransaction({
      id: data?.id,
      first_month: data?.first_month,
      transaction_dap: data?.transaction_dap,
      status: data?.status,
    });
    
    if(self_upload_type === 'water_meter'){
      const detailId = data?.items?.[0]?.id || data?.id; 
      fetchHistoryDetail(detailId);
      setDataState((prev) => ({
        ...prev,
        transection_details_id: detailId,
      }));
    }else{
      fetchHistoryDetail(data?.id);
    }
  }

  const handleSelectItem = (item, parentData) => {
    setShowDeleteIdx(null);
    setSelectedItem(item);
    const detailId = item?.id;
    
    setDataState((prev) => ({
      ...prev,
      transection_details_id: detailId,
    }));

    handleSelectTransaction({
      id: parentData?.id,
      first_month: item?.first_month,
      transaction_dap: item?.transaction_dap,
      status: item?.status,
    });
    
    fetchHistoryDetail(detailId);
    setDataState((prev) => ({
      ...prev,
      transection_details_id: detailId,
    }));
  }


  const handleClickDetailsItem = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    if (selectId === id) {
      setIsDetailsOpen(false);
      setSelectId("");
    } else {
      setSelectId(id);
      setIsDetailsOpen(true);
      // Scroll to the opened item after a short delay to ensure DOM is updated
      setTimeout(() => {
        const element = billItemRefs.current[id]; 
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  const filteredHistory = indexTransaction === -1 ? history : history?.filter( h => h.serial_number === historyDetail?.serial_number);

  console.log(filteredHistory);

  const STATUS_CONFIG = {
    calculated: {
      label: 'Calculated',
      color: '#065F46',
      bg: '#D1FAE5',
      border: '#6EE7B7',
    },
    not_calculated: {
      label: 'Not Calculated',
      color: '#92400E',
      bg: '#FEF3C7',
      border: '#F59E0B',
    },
    failed: {
      label: 'Failed',
      color: '#7F1D1D',
      bg: '#FEE2E2',
      border: '#EF4444',
    },
  };

  const STATUS_ALIAS = {
    calculated: 'calculated',
    'not calculated': 'not_calculated',
    error: 'failed',
    failed: 'failed',
  };

  const getStatusConfig = (status) => {
    if (!status) return STATUS_CONFIG.calculated;

    const normalized = status.toLowerCase().trim();
    const mappedKey = STATUS_ALIAS[normalized] || 'calculated';

    return STATUS_CONFIG[mappedKey];
  };


  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {self_upload_type === 'bill' && selectServer?.code !== 'huawei' && selectTransaction?.id && (
        <Box sx={{ position: "absolute", top: 12, left: '35%',width: "70%" }}>
          <Box sx={{ width: "50%", display: "flex", flexDirection: "row" }}>
            <Box sx={{ width: "fit-content", height: "37px", borderRadius: "8px 0px 0px 8px", padding: "0px 10px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgb(221, 221, 221)", cursor: indexTransaction > 0 ? "pointer" : "not-allowed" }} onClick={handleBackTransaction}>
              <ArrowLeftIcon color={indexTransaction > 0 ? "primary" : "disabled"}/>
            </Box>
              <CustomAutocompleteBill
                disableClearable
                options={history?.length > 0 ? history : []}
                getOptionLabel={(option) => option?.status === "success"
                  ? option?.title
                  : option?.invoice_name || 'ไม่ระบุ'}
                value={history?.[indexTransaction]}
                groupBy={(option) => option.status === "failed" ? "failed" : option.bill_type}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      readOnly: true,
                      sx: {
                        userSelect: "none",
                        "& input": {
                          cursor: "pointer",
                          caretColor: "transparent",
                        },
                      },
                    }}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                )}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <List
                      key={key}
                      {...optionProps}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        paddingY: 0,
                        backgroundColor: selected ? "#eef7f5" : "white",
                        gap: 1
                      }}
                    >
                      <Box>
                        {option?.status === "failed" ? (
                          <GradienCancelIcon fontSize="25px" />
                        ) : (
                          <GradienCheckCircleIcon fontSize="25px" />
                        )}
                      </Box>

                      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <ListItemText
                          primary={option?.status === "success"
                            ? option?.title
                            : option?.invoice_name || 'ไม่ระบุ'}
                          secondary={option?.status === "success" 
                            ? option?.serial_number || new Date(option?.emission_date).toLocaleDateString("th-TH")
                            : option?.file_name}
                          primaryTypographyProps={{
                            sx: {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              width: '70%',
                              whiteSpace: 'nowrap',
                            }
                          }}
                        />
                      </Box>

                      {option?.status === "failed" && (
                        <Typography variant="caption" color="red" sx={{ fontSize: '10px', marginLeft: 1 }}>
                          {option?.reason}
                        </Typography>
                      )}
                    </List>
                  );              
                }}
                renderGroup={(params) => {
                  return (
                    <Box key={params.key}>
                      <Box sx={{ display: "flex", paddingLeft: "20px" }}>  
                        <Box variant="body2" sx={{ marginBottom: "5px" }}> {params.group?.charAt(0).toUpperCase() + params.group?.slice(1) || 'ไม่มีระบุประเภท'} {params.children.length} transaction(s)</Box>
                        {params.group === "failed" && (
                            <Tooltip
                              title={
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    width: "100%",
                                    maxWidth: "300px",
                                    color: "white",
                                  }}
                                >
                                  The file you uploaded could not be read. This may be due
                                  to poor image quality, an incorrect bill format, or an
                                  unsupported file type.
                                </Typography>
                              }
                            >
                              <IconButton>
                                <InfoIcon sx={{ fontSize: "15px" }} />
                              </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                      <List sx={{ p: 0 }}>{params.children}</List>
                    </Box>
                  )
                }}
                onChange={(event, value) => {
                  const selectedIndex = history.findIndex(item => item.id === value?.id);
                  setIndexTransaction(selectedIndex);
                  handleSelectDetail(value);
                }}
              />
              <Box sx={{ width: "fit-content", height: "37px", borderRadius: "0px 8px 8px 0px", padding: "0px 10px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgb(221, 221, 221)", cursor: indexTransaction < history?.length - 1 ? "pointer" : "not-allowed" }} onClick={handleNewTransaction}>
                <ArrowRightIcon color={indexTransaction < history?.length - 1 ? "primary" : "disabled"}/>
              </Box>
          </Box>
        </Box>
      )}
      {selectServer?.code !== 'huawei' && (
      <Box sx={{ display: 'flex', flexDirection: mode === 'liff' ? 'column' : 'row', gap: 1, height: "100%", overflowX: 'hidden' }}>
        {self_upload_type !== 'bill' &&
        <>
          <Box sx={{ width: mode === 'liff' ? '100%' : '900px' }}>   
            {self_upload_type === 'water_meter' &&
            <Box sx={{ position: "absolute", top: 12, left: '34%',width: "70%" }}>
              <Box sx={{ width: "50%", display: "flex", flexDirection: "row" }}>
                <Box sx={{ width: "fit-content", height: "37px", borderRadius: "8px 0px 0px 8px", padding: "0px 10px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgb(221, 221, 221)", cursor: indexTransaction >= 0 ? "pointer" : "not-allowed" }} onClick={handleBackTransaction}>
                  <ArrowLeftIcon color={indexTransaction >= 0 ? "primary" : "disabled"}/>
                </Box>
                  <CustomAutocompleteBill
                    disableClearable
                    options={history?.length > 0 ? [{ display_dropdown: 'ทั้งหมด', isShowAll: true }, ...history] : []}
                    getOptionLabel={(option) => option?.display_dropdown || ''}
                    value={indexTransaction === -1 ? { display_dropdown: 'ทั้งหมด', isShowAll: true } : (history?.[indexTransaction] || null)}
                    isOptionEqualToValue={(option, value) => {
                      if (option?.isShowAll && value?.isShowAll) return true;
                      return option?.items?.[0]?.id === value?.items?.[0]?.id;
                    }}
                    groupBy={(option) => option?.isShowAll ? '' : (option.status === "failed" ? "failed" : option.bill_type)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                          sx: {
                            userSelect: "none",
                            "& input": {
                              cursor: "pointer",
                              caretColor: "transparent",
                            },
                          },
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    )}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      const statusConfig = option?.isShowAll ? null : getStatusConfig(option?.items?.[0]?.status_detail);
                      const branchName = option?.plant_partner_name || "";
                      const serialNumber = option?.serial_number || option?.items?.[0]?.serial_number || "";
                      const displayText = option?.isShowAll 
                        ? 'ทั้งหมด' 
                        : (option?.status === "success" ? option?.title : branchName || 'ไม่ระบุ');
                      const secondaryText = !option?.isShowAll && serialNumber 
                        ? (branchName ? `Serial Number: ${serialNumber}` : `Serial Number: ${serialNumber}`)
                        : "";
                      return (
                        <List
                          key={key}
                          {...optionProps}
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            paddingY: 0,
                            backgroundColor: selected ? "#eef7f5" : "white",
                            gap: 1
                          }}
                        >
                          {!option?.isShowAll && (
                            option?.items?.[0]?.status_detail === 'Calculated' 
                              ? <GradienCheckCircleIcon fontSize="25px" />
                              : <Box sx={{ width: '30px', minWidth: '30px' }} />
                          )}

                          <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'between' }}>
                            <ListItemText
                              primary={displayText}
                              secondary={secondaryText}
                              primaryTypographyProps={{
                                sx: {
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  width: '70%',
                                  whiteSpace: 'nowrap',
                                  fontWeight: option?.isShowAll ? 'bold' : 'normal',
                                }
                              }}
                              secondaryTypographyProps={{
                                sx: {
                                  fontSize: '12px',
                                  color: 'text.secondary',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }
                              }}
                            />
                            {statusConfig && (
                              <Box sx={{ 
                                border: `1px solid ${statusConfig.border}`,
                                borderRadius: '12px',
                                padding: '2px 6px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                transition: 'all 0.2s ease-in-out',
                                backgroundColor: statusConfig.bg,
                                boxShadow: `0 1px 3px ${statusConfig.border}30`,
                                flexShrink: 0,
                                whiteSpace: 'nowrap',
                              }}>
                                <Typography sx={{ 
                                  fontSize: "10px", 
                                  color: statusConfig.color, 
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  lineHeight: 1.2,
                                }}>{statusConfig.label}</Typography>
                              </Box>
                            )}
                          </Box>
                        </List>
                      );              
                    }}
                    onChange={(event, value) => {
                      if (value?.isShowAll) {
                        setIndexTransaction(-1);
                        // เมื่อเลือก "ทั้งหมด" ให้ highlight กลับมาที่การ์ดแรก
                        if (history?.[0]) {
                          handleSelectDetail(history[0]);
                        }
                        return;
                      }
                      const selectedIndex = history.findIndex(h => h.items?.[0]?.id === value?.items?.[0]?.id);
                      setIndexTransaction(selectedIndex);
                      handleSelectDetail(value);
                    }}
                  />
                  <Box sx={{ width: "fit-content", height: "37px", borderRadius: "0px 8px 8px 0px", padding: "0px 10px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgb(221, 221, 221)", cursor: (indexTransaction === -1 || indexTransaction < history?.length - 1) ? "pointer" : "not-allowed" }} onClick={handleNewTransaction}>
                    <ArrowRightIcon color={(indexTransaction === -1 || indexTransaction < history?.length - 1) ? "primary" : "disabled"}/>
                  </Box>
              </Box>
            </Box>    
            }
            <Box sx={{ height: mode === 'liff' ? 'fit-content' : '65vh',overflowY: "auto", padding: mode === 'liff' ? '0px' : '0px 10px' }}>
                {(history?.length > 0 && self_upload_type === 'water_meter') ? (                  
                  <Box>
                    {filteredHistory?.map((h, idx) => {
                      const isSerialSelected = historyDetail?.serial_number 
                        ? historyDetail?.serial_number === h?.serial_number 
                        : idx === 0;
                      return (
                        <Box 
                          key={h?.serial_number} 
                          onClick={(e) => {
                            e.stopPropagation();
                            if (h?.items?.length > 0) {
                              handleSelectItem(h?.items[0], h);
                            }
                          }}
                          sx={{
                            mb: 3,
                            p: 2,
                            borderRadius: '16px',
                            border: isSerialSelected ? '2px solid' : '1px solid',
                            borderColor: isSerialSelected ? 'primary.main' : '#E0E3E7',
                            boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
                            backgroundColor: isSerialSelected ? 'primary.light' : 'white',
                            cursor: 'pointer',
                          }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                            {/* Show Serial Number and Status only once */}
                            {h?.items?.length > 0 && (
                              <Box sx={{ display: 'flex', gap: 1, justifyContent: "space-between", alignItems: 'center', marginBottom: "2px" }}>
                                <Typography sx={{ fontSize: "14px", fontWeight: "bold", marginLeft: "10px", color: 'primary.main' }}>
                                  <span style={{ color: 'gray' }}>Serial Number: </span>{h?.serial_number}
                                </Typography>
                                {(() => {
                                  const firstItem = h?.items?.[0];
                                  const statusConfig = getStatusConfig(firstItem?.status_detail);
                                  return (
                                    <Box sx={{ 
                                      border: `1px solid ${statusConfig.border}`,
                                      borderRadius: '12px',
                                      padding: '2px 6px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                      transition: 'all 0.2s ease-in-out',
                                      backgroundColor: statusConfig.bg,
                                      boxShadow: `0 1px 3px ${statusConfig.border}30`,
                                      flexShrink: 0,
                                      whiteSpace: 'nowrap',
                                    }}>
                                      <Typography sx={{ 
                                        fontSize: "10px", 
                                        color: statusConfig.color, 
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        lineHeight: 1.2,
                                      }}>{statusConfig.label}</Typography>
                                    </Box>
                                  );
                                })()}
                              </Box>
                            )}
                            {/* Show Period and Meter Number Period only once (from first item) */}
                            <Typography sx={{ fontSize: "14px", fontWeight: "bold", marginLeft: "10px", color: 'primary.main' }}>
                              <span style={{ color: 'gray' }}>Period: </span>{h?.items?.[0]?.period || "-"}
                            </Typography>
                            <Typography sx={{ fontSize: "14px", fontWeight: "bold", marginLeft: "10px", color: 'primary.main' }}>
                              <span style={{ color: 'gray' }}>Meter Number Period: </span>{h?.items?.[0]?.meter_number_period || "-"}
                            </Typography>
                            <Typography sx={{ fontSize: "14px", fontWeight: "bold", marginLeft: "10px", color: 'primary.main' }}>
                              <span style={{ color: 'gray' }}>Amount: </span>{h?.unit ? `${h?.unit} m³` : "-"}
                            </Typography>
                          </Box>
                          {h?.items?.map((item, i) => {
                            const isItemSelected = historyDetail?.id === item?.id;
                            const isFirstItemOfSelectedSerial = isSerialSelected && i === 0 && !selectedItem;
                            const isItemHighlighted = selectedItem?.id === item?.id || (isItemSelected && !selectedItem) || isFirstItemOfSelectedSerial;
                            return (
                              <Box 
                                key={item?.id} 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(item, h);
                                }}
                                sx={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  justifyContent: 'space-between', 
                                  gap: 1, 
                                  borderRadius: '12px', 
                                  padding: '10px', 
                                  border: isItemSelected ? '2px solid' : '1px solid', 
                                  borderColor: isItemHighlighted ? 'primary.main' : '#E0E3E7', 
                                  // borderColor: isItemSelected ? '#4CAF50' : '#E0E3E7', 
                                  // boxShadow: isItemSelected ? 'primary.main' : '#E0E3E7', 
                                  marginTop: '10px', 
                                  backgroundColor: item?.transaction_dap ? '#3dbb89' : (isItemHighlighted ? 'primary.light' : 'white'),
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease-in-out',
                                  '&:hover': {
                                    borderColor: isItemSelected ? '#4CAF50' : 'primary.main',
                                    boxShadow: isItemSelected ? 'primary.main' : '#E0E3E7',
                                  }
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Box>
                                    {item?.status_detail === 'Calculated' && <GradienCheckCircleIcon fontSize="25px" />}
                                  </Box>
                                  <Box>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        gridColumn: "1 / span 4",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        color: item?.transaction_dap ? 'white' : 'gray',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {item?.activity_date
                                      ? new Date(item?.activity_date).toLocaleDateString("th-TH", {
                                        day: "2-digit",
                                        month: "long",
                                        year: "numeric",
                                      })
                                        : ""}
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        gridColumn: "1 / span 4",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        color: item?.transaction_dap ? 'white' : 'primary.main',
                                      }}
                                    >
                                      <span style={{ color: item?.transaction_dap ? 'primary.dark' : 'gray', fontSize: '14px' }}>
                                        Meter Number: 
                                      </span> &nbsp;
                                      <span style={{ fontWeight: 'bold'}}>
                                        {item?.status === "success" ? item?.title || item?.meter_reading : item?.invoice_name}
                                      </span>
                                    </Typography>

                                    {item?.status !== "success" && (
                                      <Typography
                                        variant="caption"
                                        component="p"
                                        sx={{
                                          pr: 2,
                                          gridColumn: "span 8 / span 8",
                                          width: "100%",
                                          fontWeight: 700,
                                          color: "red",
                                          flexShrink: 0,
                                          textAlign: "right",
                                        }}
                                      >
                                        {item?.reason}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                                {item?.status === "success" && (
                                  <Box
                                    sx={{
                                      mr: 1,
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  >
                                    <IconButton
                                      aria-describedby={id}
                                      onClick={(e) => {
                                        setAnchorEl(e.currentTarget);
                                        e.stopPropagation();
                                        setShowDeleteIdx(i);
                                      }}
                                    >
                                      <MoreHorizIcon />
                                    </IconButton>
                                    <Popover
                                      id={id}
                                      open={open}
                                      anchorEl={anchorEl}
                                      onClose={handleClose}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                      }}
                                    >
                                      <ListItem sx={{ padding: '5px' }}>
                                        <ListItemButton sx={{ padding: '7px', borderRadius: '12px' }} onClick={(e) => {
                                          e.stopPropagation();
                                        }}>
                                          <ListItemIcon 
                                            sx={{ minWidth: 0 }}>
                                            <DeleteIcon color="error" />
                                          </ListItemIcon>
                                          <ListItemText primary="Delete" sx={{ padding: '0px 10px' }} />
                                        </ListItemButton>
                                     </ListItem>
                                    </Popover>
                                  </Box>
                                )}
                              </Box>
                            );
                          })}
                        </Box>
                      );
                    })}
                  </Box>
                )
                : title_transition?.map((t, i) => {
                  const failed = history?.filter(
                    (h) => h?.status === "failed" && t?.name === h?.status
                  );
                  const success = history?.filter(
                    (h) =>
                      h?.status === "success" &&
                      t?.name === h?.status &&
                      (t?.type === h?.bill_type || t?.type === h?.detail_type)
                  );
                  if (failed?.length > 0 || success?.length > 0) {
                    return (
                      <Box key={i}>
                        <Box sx={{ fontWeight: "bold" }}>
                          <Typography variant="h7" sx={{ marginLeft: "10px" }}>
                            {t?.display_name}{" "}
                            {
                              history?.filter((h) =>
                                h?.status === "failed"
                                  ? h?.status === t?.name
                                  : h?.status === t?.name && (h?.bill_type === t?.type || h?.detail_type === t?.type)
                              ).length
                            }{" "}
                            transaction(s)
                          </Typography>
                          <Tooltip
                            title={
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  marginTop: "5px",
                                  width: "100%",
                                  maxWidth: "300px",
                                  color: "white",
                                }}
                              >
                                The file you uploaded could not be read. This may be due
                                to poor image quality, an incorrect bill format, or an
                                unsupported file type.
                              </Typography>
                            }
                          >
                            {t?.name === "failed" && (
                              <IconButton>
                                <InfoIcon sx={{ fontSize: "15px" }} />
                              </IconButton>
                            )}
                          </Tooltip>
                        </Box>

                        <Box>
                          <List dense={true}>
                            {history?.map((h, i) => {
                              const Success =
                                h?.status === "success" &&
                                t?.name === h?.status &&
                                (t?.type === h?.bill_type || t?.type === h?.detail_type);
                              const Failed =
                                h?.status === "failed" && t?.name === h?.status;
                              if (Failed || Success) {
                                const date = new Date(h?.emission_date);
                                const monthShort = dayjs(h?.activity_date || h?.emission_date).format('MMM');

                                return (
                                  <ListItem
                                    key={h?.id}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      backgroundColor: h?.transaction_dap ? '#3dbb89' : 'white',
                                      color: h?.transaction_dap ? 'white' : 'black',
                                      boxShadow: h?.first_month ? '0px 0px 10px 0px rgba(0, 0, 0, 0.1)' : 'none',
                                      border: selectTransaction?.id === h?.id ? '2px solid' : '1px solid',
                                      borderColor: selectTransaction?.id === h?.id ? 'rgb(140, 140, 140)' : '#E0E3E7',
                                      textShadow: h?.first_month ? '1px 1px 3px rgba(0,0,0,0.3)' : 'none',
                                      borderRadius: "10px",
                                      padding: "6px 0",
                                      marginBottom: "5px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {h?.first_month && (
                                      <Box sx={{ position: "absolute", right: 50, top: -12 }}><GradienFirstMonthIcon fontSize="60px" /><Typography sx={{ fontSize: "12px", color: "white", fontWeight: "bold", position: "absolute", top: 8, right: 19, zIndex: 10005, textShadow: "1px 1px 3px rgba(0,0,0,0.5)", }}>{monthShort}</Typography><Typography sx={{ fontSize: "15px", color: "white", fontWeight: "bold", position: "absolute", top: 23, right: 25, zIndex: 10005, textShadow: "1px 1px 3px rgba(0,0,0,0.5)" }}>1</Typography>
                                      </Box>
                                    )}
                                    {h?.status === "failed" ? (
                                      <GradienCancelIcon fontSize="25px" />
                                    ) : (
                                      <GradienCheckCircleIcon fontSize="25px" />
                                    )}

                                    <Box sx={{ width: "100%" }} onClick={() => handleSelectDetail(h)}>
                                      <Box
                                        sx={{
                                          display: "grid",
                                          gridTemplateColumns:
                                            h?.status !== "success"
                                              ? "repeat(12, 1fr)"
                                              : "1fr",
                                          alignItems: "center",
                                          gap: "4px",
                                          width: "100%",
                                        }}
                                      >
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            gridColumn: "1 / span 4",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {h?.status === "success" ? h?.title || h?.meter_reading : h?.invoice_name}
                                        </Typography>

                                        {h?.status !== "success" && (
                                          <Typography
                                            variant="caption"
                                            component="p"
                                            sx={{
                                              pr: 2,
                                              gridColumn: "span 8 / span 8",
                                              width: "100%",
                                              fontWeight: 700,
                                              color: "red",
                                              flexShrink: 0,
                                              textAlign: "right",
                                            }}
                                          >
                                            {h?.reason}
                                          </Typography>
                                        )}
                                      </Box>
                                      <Typography
                                        component="p"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          color: h?.transaction_dap ? 'white' : 'gray',
                                        }}
                                      >
                                        {h?.status === "success"
                                          ? h?.serial_number || date.toLocaleDateString("th-TH")
                                          : h?.file_name || h?.invoice_name}
                                      </Typography>
                                    </Box>

                                    {h?.status === "success" && (
                                      <Box
                                        sx={{
                                          mr: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                        }}
                                      >
                                        <IconButton
                                          aria-describedby={id}
                                          onClick={(e) => {
                                            setAnchorEl(e.currentTarget);
                                            e.stopPropagation();
                                            setShowDeleteIdx(i);
                                          }}
                                        >
                                          <MoreHorizIcon />
                                        </IconButton>
                                        <Popover
                                          id={id}
                                          open={open}
                                          anchorEl={anchorEl}
                                          onClose={handleClose}
                                          anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                          }}
                                        >
                                          <ListItem sx={{ padding: '5px' }}>
                                            <ListItemButton sx={{ padding: '7px', borderRadius: '12px' }} onClick={(e) => {
                                              e.stopPropagation();
                                            }}>
                                              <ListItemIcon 
                                                sx={{ minWidth: 0 }}>
                                                <DeleteIcon color="error" />
                                              </ListItemIcon>
                                              <ListItemText primary="Delete" sx={{ padding: '0px 10px' }} />
                                            </ListItemButton>
                                          </ListItem>
                                        </Popover>
                                      </Box>
                                    )}
                                  </ListItem>
                                );
                              }
                              return null;
                            })}
                          </List>
                        </Box>
                      </Box>
                    );
                  }
                  return null;
                })}
            </Box>
          </Box>
        </>
        }
        
        {self_upload_type === 'xlsx_csv_waste' || self_upload_type === 'xlsx_csv_travelling' ? (
          <>
            <Box 
              key={`transaction-form-${selectTransaction?.id || historyDetail?.id || 'default'}`}
              sx={{ height: "100%", width: mode === 'liff' ? '100%' : '100%', position: "relative", p: mode === 'liff' ? 0 : 3 }}
            >
              {historyDetail && (Object.keys(transactions)?.length > 0 || historyDetail?.details?.length > 0) ? (
                <Box sx={{ height: mode === 'liff' ? 'fit-content' : '65vh' }}>
                  <Stack gap={2}>
                    {(Object.keys(transactions)?.length > 0 ? Object.values(transactions) : historyDetail?.details || []).map((item, index) => {
                      return (
                        <Box
                          key={item?.id || index}
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                            gap: 1,
                            p: 2,
                            border: "1px solid rgba(0, 0, 0, 0.12)",
                            borderRadius: "12px",
                            backgroundColor: "white",
                            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                          }}
                          component="form"
                          onSubmit={(e) => {
                            e.preventDefault();
                            const itemKey = item?.id || index;
                            const itemData = formData[itemKey] || {
                              activity_date: item?.activity_date?.split("T")[0] || "",
                              upload_date: item?.upload_date?.split("T")[0] || "",
                              bill_type: item?.bill_type || "",
                              type: item?.type || "",
                              unit: item?.unit ? formatNumber(item?.unit, 2) : "",
                            };
                            onSave({ ...itemData, id: item?.id, itemId: item?.id });
                          }}
                          noValidate
                          ref={formRef}
                        >
                          <Box>
                            <Typography variant="caption" sx={{ fontSize: "11px", color: "text.secondary", display: "block", mb: 0.5 }}>
                              Activity Date
                            </Typography>
                            <TextField
                              {...register(`activity_date_${item?.id || index}`, {
                                required: "Activity date is required",
                              })}
                              value={formData[item?.id || index]?.activity_date ?? item?.activity_date?.split("T")[0] ?? ""}
                              onChange={(e) => {
                                setValue(`activity_date_${item?.id || index}`, e.target.value);
                                setFormData(prev => ({ 
                                  ...prev, 
                                  [item?.id || index]: { 
                                    ...prev[item?.id || index], 
                                    activity_date: e.target.value 
                                  } 
                                }));
                              }}
                              error={!!errors?.[`activity_date_${item?.id || index}`]}
                              variant="outlined"
                              type="date"
                              fullWidth
                              sx={{
                                ".MuiInputBase-root": {
                                  width: "100%",
                                  "& > .MuiInputBase-input": {
                                    padding: "8px",
                                  },
                                },
                                ".MuiOutlinedInput-notchedOutline": {
                                  borderRadius: "8px",
                                },
                                ".Mui-error .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#FF5B5B",
                                },
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography variant="caption" sx={{ fontSize: "11px", color: "text.secondary", display: "block", mb: 0.5 }}>
                              Upload Date
                            </Typography>
                            <TextField
                              {...register(`upload_date_${item?.id || index}`, {
                                required: "Upload date is required",
                              })}
                              value={formData[item?.id || index]?.upload_date ?? item?.upload_date?.split("T")[0] ?? ""}
                              onChange={(e) => {
                                setValue(`upload_date_${item?.id || index}`, e.target.value);
                                setFormData(prev => ({ 
                                  ...prev, 
                                  [item?.id || index]: { 
                                    ...prev[item?.id || index], 
                                    upload_date: e.target.value 
                                  } 
                                }));
                              }}
                              error={!!errors?.[`upload_date_${item?.id || index}`]}
                              variant="outlined"
                              type="date"
                              fullWidth
                              sx={{
                                ".MuiInputBase-root": {
                                  width: "100%",
                                  "& > .MuiInputBase-input": {
                                    padding: "8px",
                                  },
                                },
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography variant="caption" sx={{ fontSize: "11px", color: "text.secondary", display: "block", mb: 0.5 }}>
                              Bill type
                            </Typography>
                            <TextField
                              {...register(`bill_type_${item?.id || index}`, {
                                required: "Bill type is required",
                              })}
                              value={formData[item?.id || index]?.bill_type ?? item?.bill_type ?? ""}
                              // value={item?.bill_type || null}
                              onChange={(e) => {
                                setValue(`bill_type_${item?.id || index}`, e.target.value);
                                setFormData(prev => ({ 
                                  ...prev, 
                                  [item?.id || index]: { 
                                    ...prev[item?.id || index], 
                                    bill_type: e.target.value 
                                  } 
                                }));
                              }}
                              error={!!errors?.[`bill_type_${item?.id || index}`]}
                              variant="outlined"
                              type="text"
                              fullWidth
                              sx={{
                                ".MuiInputBase-root": {
                                  width: "100%",
                                  "& > .MuiInputBase-input": {
                                    padding: "8px",
                                  },
                                },
                              }}
                            />
                           
                          </Box>
                          <Box>
                            <Typography variant="caption" sx={{ fontSize: "11px", color: "text.secondary", display: "block", mb: 0.5 }}>
                              Type
                            </Typography>
                            <TextField
                              {...register(`type_${item?.id || index}`, {
                                required: "Type is required",
                              })}
                              value={formData[item?.id || index]?.type ?? item?.type ?? ""}
                              // value={item?.type || null}
                              onChange={(e) => {
                                setValue(`type_${item?.id || index}`, e.target.value);
                                setFormData(prev => ({ 
                                  ...prev, 
                                  [item?.id || index]: { 
                                    ...prev[item?.id || index], 
                                    type: e.target.value 
                                  } 
                                }));
                              }}
                              error={!!errors?.[`type_${item?.id || index}`]}
                              variant="outlined"
                              type="text"
                              fullWidth
                              sx={{
                                ".MuiInputBase-root": {
                                  width: "100%",
                                  "& > .MuiInputBase-input": {
                                    padding: "8px",
                                  },
                                },
                              }}
                            />
                          
                          </Box>
                          <Box>
                            <Typography variant="caption" sx={{ fontSize: "11px", color: "text.secondary", display: "block", mb: 0.5 }}>
                              Unit ( {item?.unit_type} )
                            </Typography>
                            <TextField
                              {...register(`unit_${item?.id || index}`, {
                                required: "Unit is required",
                              })}
                              value={formData[item?.id || index]?.unit ?? formatNumber(item?.unit, 2) ?? ""}
                              // value={formatNumber(item?.unit, 2) || item?.unit || null}
                              onChange={(e) => {
                                setValue(`unit_${item?.id || index}`, e.target.value);
                                setFormData(prev => ({ 
                                  ...prev, 
                                  [item?.id || index]: { 
                                    ...prev[item?.id || index], 
                                    unit: e.target.value 
                                  } 
                                }));
                              }}
                              error={!!errors?.[`unit_${item?.id || index}`]}
                              variant="outlined"
                              type="text"
                              fullWidth
                              sx={{
                                ".MuiInputBase-root": {
                                  width: "100%",
                                  "& > .MuiInputBase-input": {
                                    padding: "8px",
                                  },
                                },
                              }}
                            />
                            
                          </Box>
                        </Box>
                      );
                    })}
                  </Stack>
                </Box>
              ) : (
                <Box sx={{ color: "gray", height: "100%", backgroundColor: "#F3FAF8", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px", minHeight: "200px", marginRight: "20px" }}>
                  No data available
                </Box>
              )}
            </Box>
          </>) : (
          <>
          <Box sx={{ height: "100%", width: mode === 'liff' ? '100%' : self_upload_type === 'bill' ? '70%' : '100%', position: "relative" }}>
              {historyDetail?.blob_url || historyDetailImage ? (
                <ImagePreviewWithOverview
                  imageUrl={historyDetail?.blob_url || historyDetailImage}
                  fileType={historyDetail?.type_file}
                />
              ):(
                <Box sx={{ color: "gray", height: "100%", backgroundColor: "#F3FAF8", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px" }}>
                  No image available
                </Box>
              )}
          </Box> 
          <Box sx={{ height: "100%", width: mode === 'liff' ? '100%' : self_upload_type === 'bill' ? '30%' : self_upload_type === 'water_meter' ? '70%' :'100%', position: "relative" }}>
            {Object.keys(transactions)?.length > 0 ?
                <Box sx={{ height: mode === 'liff' ? 'fit-content' : '65vh', overflowY: "auto" }}>
                  {historyDetail && (
                    <Box
                      ref={formRef}
                      component="form"
                      onSubmit={handleSubmit(onSave)}
                      noValidate
                      sx={{
                        p: mode === 'liff' ? 0 : 1,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    > 
                      {self_upload_type !== 'water_meter' && (
                        <Typography variant="h5" sx={{ mb: 1, fontWeight: "bold" }}>
                          Bill Info
                        </Typography>
                      )}
                        {self_upload_type === 'water_meter' ? (
                          <WaterMeterFormContent
                            control={control}
                            register={register}
                            errors={errors}
                            serialNumberList={serialNumberList}
                            aliasOptions={aliasOptions}
                            tansactionById={tansactionById}
                            waterDetail={historyDetail}
                            setValue={setValue}
                          />
                        ) :(
                        <Box sx={{ width: '100%' }}>
                          {historyDetail?.details?.length > 0 && (
                            <>
                            {historyDetail?.details?.length === 1 ? (
                              <Box sx={{ position: 'relative' }}>
                                <Box sx={{ position:"absolute", top: -34, right: 0 }}>
                                  <Typography variant="caption" color="red" sx={{ fontSize: '12px' }}>
                                    {historyDetail?.details?.[0]?.reason || ''}
                                  </Typography>
                                </Box>
                                <BillFormContent 
                                  billData={historyDetail?.details[0]}
                                  index={0}
                                  register={register}
                                  errors={errors}
                                  setValue={setValue}
                                  watch={watch}
                                  assets={assets}
                                  isLoadingAssets={isLoadingAssets}
                                  onAssetsDropdownOpen={getAssetsById}
                                  setIsOpenDialog={setIsOpenDialog}
                                  _emissions={_emissions}
                                  mode={mode}
                                />
                              </Box>

                            ):(
                              <Box>
                                {historyDetail?.details?.map((billData, index) => (
                                  <Box 
                                    key={index} 
                                    ref={(el) => {
                                      if (billData?.id) {
                                        billItemRefs.current[billData.id] = el;
                                      }
                                    }}
                                    sx={{ marginBottom: '10px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '10px' }}
                                  >
                                    <Box 
                                      onClick={(e) => handleClickDetailsItem(e, billData?.id)}
                                      sx={{ cursor: 'pointer', userSelect: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}
                                    >
                                      {billData?.invoice_id || `Bill ${index + 1}`}
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography variant="caption" color="red" sx={{ fontSize: '12px' }}>
                                          {billData?.reason || ''}
                                        </Typography>
                                        <i className={`ri-arrow-down-s-line text-primary text-xl transition-transform ${isDetailsOpen && selectId === billData?.id ? "rotate-180" : ""}`} style={{ fontSize: '16px' }}></i>
                                      </Box>
                                    </Box>

                                    {isDetailsOpen && selectId === billData?.id && (
                                    <Box sx={{ mt: 2 }}>
                                      <BillFormContent 
                                          billData={billData}
                                          index={index}
                                          register={register}
                                          errors={errors}
                                          setValue={setValue}
                                          watch={watch}
                                          assets={assets}
                                          isLoadingAssets={isLoadingAssets}
                                          onAssetsDropdownOpen={getAssetsById}
                                          setIsOpenDialog={setIsOpenDialog}
                                          _emissions={_emissions}
                                          mode={mode}
                                        />
                                    </Box>
                                    )}

                                  </Box>
                                ))}
                              </Box>
                            )}
                            </>
                          )}
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
                : 
                <Box sx={{ color: "gray", height: "100%", backgroundColor: "#F3FAF8", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px", marginRight: "20px" }}>
                  No data available
                </Box>
            }
          </Box>
          </>
        )}
      </Box>
      )}

    {selectServer?.code === 'huawei' && (
      <HuaweiContent selectedStation={selectedStation} setSelectedStation={setSelectedStation} />  
    )}

      <DialogCreateAsset
        open={isOpenDialog}
        onClose={handleCloseDialogCreateAsset}
      />
      {selectServer?.code === 'ai_training' && (
      <DialogImageAnnotate
        open={openAnnotate}
        onClose={() => setOpenAnnotate(false)}
        imageUrl={historyDetail?.blob_url || historyDetailImage}
        autoRunOcr={true}
      />
      )}
    </Box>
  );
});

export default function DialogDeviceDetails() {

  const queryParams = new URLSearchParams(window.location.search);
  const transaction_id = queryParams.get("id");
  const [isErr, setIsErr] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [selectTransaction, setSelectTransaction] = useState({
    id: null,
    first_month: null,
    transaction_dap: null,
    status: null,
  });
  const { loading, dialog, setDataState, history, assignFirstMonth, mode, selectServer, self_upload_type, transactionId, exportTransactionFile, tansactionById } = useContext(DataSourceContext);
  const formRef = useRef(null);

  const handleClose = () => {
    setIsErr(false);
    setSelectTransaction({
      id: null,
      first_month: null,
      transaction_dap: null,
      status: null,
    });
    setDataState((prev) => ({
      ...prev,
      dialog: {
        ...prev.dialog,
        device_details: false,
      },
      history: [],
      historyDetail: null,
      historyDetailImage: null,
    }));
  };

  const handleFirstMonth = () => {
    assignFirstMonth(selectTransaction?.id);
    setSelectTransaction({
      id: null,
      first_month: null,
      transaction_dap: null,
      status: null,
      historyDetailImage: null,
    });
  };

  const handleConfirm = () => {
    formRef.current?.handleSaveChanges();
  };

  const handleExport = async () => {
    try {
      if (!transactionId) return;

      setLoadingExport(true);
      const response = await exportTransactionFile(transactionId);
      setLoadingExport(false);
      if (response?.data) {
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const filename = `transactions_${transactionId}.xlsx`;
        
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
        
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        setLoadingExport(false);
      }
    } catch (error) {
      console.error("Export failed:", error);
    }
  };


  return (
    <MyDialog
      Header={
        isErr ? null : selectServer?.code === 'huawei' 
          ? `${history?.length} station(s) have been synced`
          : self_upload_type === 'water_meter' ? `${tansactionById?.title}` : `${history?.length} transaction(s) have been synced`
      }
      open={dialog.device_details}
      actionContent
      isTextCancel={(mode === 'liff' && transaction_id) ? false : true}
      textConfirm={'Save'}
      isTextConfirm={selectServer?.code === 'huawei' ? false : true}
      textCancel={selectServer?.code === 'huawei' ? 'Close' : 'Cancel'}
      handleClose={(mode === 'liff' && transaction_id) ? () => {} : handleClose}
      handleConfirm={handleConfirm}
      loading={loading?.modal}
      maxHeight="80vh"
      minWidth="90vw"
      customStyle={{
        "& .MuiDialogContent-root": {
          paddingBottom: "0 !important",
          ...(selectServer?.code === 'huawei' ? {
            overflow: "visible !important",
            zIndex: 10001,
          } : {
            overflow: "hidden !important",
            zIndex: 10001,
          }),
        },
        "& .MuiDialog-paper": {
          overflow: selectServer?.code === 'huawei' ? "visible !important" : "hidden !important",
          // Center dialog on entire screen (including sidebar)
          left: "calc(50% + 32px) !important",
          transform: "translateX(-50%) !important",
        },
      }}
    >
      {isErr ? (
        <ContentsErr onClick={setIsErr} />
      ) : (
        // {
        //   bills: <Contents onClick={setIsErr} />,
        //   ocrs: <OCRSContents onClick={() => {}} />,
        // }[selectServer?.name.toLowerCase()]
        <>
        {(selectServer?.code !== 'huawei' && self_upload_type !== 'water_meter') && (
        <IconButton
          onClick={handleExport}
          disabled={loadingExport}
          sx={{
            backgroundColor: loadingExport ? 'grey.400' : 'primary.main',
            color: 'white',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
            zIndex: 10001,
            borderRadius: '8px',
            padding: '8px',
            position: 'absolute',
            top: '18px',
            right: '10px',
          }}
        >
            <FileDownloadIcon fontSize="small" />
            <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 'bold', display: 'block' }}>
              {loadingExport ? 'Exporting...' : 'Export'}
            </Typography>
        </IconButton>
        )}
        <OCRSContents ref={formRef} onClick={setIsErr} selectTransaction={selectTransaction} handleSelectTransaction={setSelectTransaction} />
        </>
      )}
      {/* {self_upload_type === 'water_meter' && (
        <Box 
          sx={{ 
            position: 'absolute', 
            bottom: 0, 
            right: 160, 
            padding: '10px',
        }}>
          <Button 
            variant="contained" 
            disabled={!selectTransaction?.id || selectTransaction?.status === 'failed' || selectTransaction?.transaction_dap}
            onClick={() => handleFirstMonth()}>First month</Button>
        </Box>
      )} */}
    </MyDialog>
  );
}
